/*
 * ELTANE — prefix matching for search
 *
 * Shopify's storefront search matches whole words, not prefixes. "pickle" finds
 * the Pickle Juice Shot; "pick" finds nothing, which reads as a broken search to
 * anyone who types faster than they finish a word. (The `options[prefix]=last`
 * hidden field both search forms already send makes no difference — measured.)
 *
 * The `*` wildcard does work, at every length: `pi*`, `pic*`, `pick*` all return
 * the product, and so does the last term of a phrase — `energy gel man*`. So the
 * query gets a `*` appended to its final term on the way out, both here for the
 * full search page and in predictive-search.js for the dropdown.
 *
 * The star is a query-syntax detail, not something a visitor typed, so it is
 * stripped back out for display — see the `display_terms` assign in
 * sections/main-search.liquid. It has to survive in the hidden `q` fields the
 * facet and sort forms submit, or filtering a result set would re-run the search
 * without it and empty the page.
 */
(function () {
  'use strict';

  /*
   * Cases that must not get a star:
   *   empty                — nothing to match
   *   already ends in *    — typed by hand, or a resubmitted form
   *   ends in "            — "pickle juice" is an exact-phrase search, and a
   *                          star outside the quotes is not valid syntax
   *   ends in a Shopify search operator or field filter (AND, OR, product_type:)
   */
  function withPrefixWildcard(value) {
    var terms = String(value == null ? '' : value).trim();
    if (!terms) return terms;

    var last = terms.split(/\s+/).pop();
    if (!last) return terms;
    if (last.slice(-1) === '*' || last.slice(-1) === '"' || last.slice(-1) === ':') return terms;
    if (/^(AND|OR|NOT)$/i.test(last)) return terms;

    return terms + '*';
  }

  /*
   * Rewriting input.value directly would flash the star into the box the visitor
   * is looking at as the page unloads. A hidden twin carries the starred query
   * instead, and the visible field gives up its name so only one `q` is sent.
   */
  function handleSubmit(event) {
    var form = event.target;
    if (!form || form.tagName !== 'FORM') return;
    if (!form.matches('form[role="search"], form.search')) return;

    var input = form.querySelector('input[name="q"]:not([type="hidden"])');
    if (!input) return;

    var starred = withPrefixWildcard(input.value);
    if (starred === input.value.trim()) return;

    var hidden = form.querySelector('[data-search-prefix-q]');
    if (!hidden) {
      hidden = document.createElement('input');
      hidden.type = 'hidden';
      hidden.setAttribute('data-search-prefix-q', '');
      form.appendChild(hidden);
    }
    hidden.name = 'q';
    hidden.value = starred;
    input.removeAttribute('name');

    /* Restore the field if the navigation never happens — a cancelled unload, a
       Back button restoring the page from cache — otherwise the box is inert
       and the next submit sends the stale starred value. */
    window.setTimeout(function () {
      input.name = 'q';
      hidden.name = '';
    }, 0);
  }

  document.addEventListener('submit', handleSubmit, true);

  /* predictive-search.js reads this off the same module boundary rather than
     duplicating the rules. */
  window.eltaneSearchPrefix = withPrefixWildcard;
})();
